export const configApiDecathlonGo = {
  'local': {
    env: 'local',
    domain: 'http://localhost',
    apiKey: '',
    service: 'api',
    version: 'v1'
  },
  'preprod': {
    env: 'preprod',
    domain: 'https://api-global.preprod.decathlon.net/decathlon_go',
    apiKey: '5a09e93d-33e7-49d9-b88b-c27b1a144d3d',
    service: 'api',
    version: 'v1'
  },
  'prod': {
    env: 'prod',
    domain: 'https://api.decathlon.net/decathlon_go',
    apiKey: '',
    service: 'api',
    version: 'v1'
  }
};



// WEBPACK FOOTER //
// ./src/_override/api/config-api-decathlon-go.js